import rarity from '../../../../assets/img/Rad-rabbit-rarity.png';
import soldout from '../../../../assets/img/soldout.png';

const BuyBunny = () => {
  return (
    <div className="buybunny">
      <div className="container">
        <div className="buybunny__content">
          <div className="buybunny__block">
            <img src={soldout} alt="" className="trait__img" />
          </div>
          <div className="buybunny__block">
            
            <h1 className="buybunny__title">Sold 7181 of 8888</h1>

            <div className="buybunny__text">
              <>
                
              </>
               <p>
                Thank you for your interest in our exclusive collection.
              </p>
              <p style={{ fontWeight: 'bold' }}>Rad Rabbits Reveal happened on December 28, 2021.</p>
              
              <p>Thank you for participating.</p>
              <br />
              <p>Join our Telegram to learn more!</p>
              <br />
              <a href="https://t.me/moonrabbitcom" className="customButton " rel="noreferrer" target="_blank">
                Join Telegram
              </a>

            </div>
          </div>
        </div>
      </div>
      <div className="rarity">
        <div className="container">
          <div className="buybunny__rarity">
            <img src={rarity} alt="" className="trait__img" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyBunny;
